module.exports = __webpack_public_path__ + "img/free.70a32992.jpg";